import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalError = _resolveComponent("ModalError")!
  const _component_ModalSuccess = _resolveComponent("ModalSuccess")!
  const _component_SpinnerDH = _resolveComponent("SpinnerDH")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_ModalError, {
      error: _ctx.hasError,
      "onUpdate:error": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.hasError) = $event)),
      message: _ctx.messageError
    }, null, 8, ["error", "message"]), [
      [_vShow, _ctx.hasError]
    ]),
    _withDirectives(_createVNode(_component_ModalSuccess, { message: _ctx.messageSuccess }, null, 8, ["message"]), [
      [_vShow, _ctx.isVisibleSuccessMessage]
    ]),
    _withDirectives(_createVNode(_component_SpinnerDH, null, null, 512), [
      [_vShow, _ctx.isVisibleSpinner]
    ]),
    _createVNode(_component_router_view)
  ], 64))
}